function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesBottleWaterFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 5.47a1 1 0 01.625-.22h3a1 1 0 01.625.22l2.488 1.99c1.003.758 1.592 1.825 1.93 2.782.34.963.457 1.9.457 2.508v16.715a1 1 0 01-1 1H10a1 1 0 01-1-1V12.75c0-2.753 1.51-4.625 2.386-5.29l2.49-1.99zm.976 1.78l-2.226 1.78a1.016 1.016 0 01-.025.02c-.46.345-1.6 1.667-1.6 3.7v15.715h10V12.75c0-.393-.083-1.105-.343-1.842-.26-.739-.668-1.417-1.257-1.858a1.016 1.016 0 01-.025-.02L17.15 7.25h-2.298z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 1.75h-4.8a.6.6 0 00-.6.6v1.4a1 1 0 001 1h4a1 1 0 001-1v-1.4a.6.6 0 00-.6-.6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.25h5v2h-5v-2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesBottleWaterFilled;